module.exports = __webpack_public_path__ + "static/media/infinity.gb.830a393c.zip";